export const sortTopicsByName = (topicsList = []) => topicsList.sort((a, b) => a.name.localeCompare(b.name));
